import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import BannerImage from "./subcomponents";
import { useRewardsConfigContext } from "../../../context/rewardsConfig";
import getClientImgSrc from "../../../helpers/imageUtils";
var RewardBanner = function (_a) {
    var client = _a.client, _b = _a.height, height = _b === void 0 ? "auto" : _b, image = _a.image, _c = _a.width, width = _c === void 0 ? "100%" : _c;
    var t = useTranslation().t;
    var config = useRewardsConfigContext().config;
    return (_jsx(BannerImage, { src: getClientImgSrc({ config: config, client: client, image: image }), alt: t("rewardsBanner.altText", {
            client: client,
        }), height: height, width: width }));
};
export default RewardBanner;
